import { SET_IS_IMPORTING } from '../../actions/entity';

export default (state = false, action) => {
  switch (action.type) {
    case SET_IS_IMPORTING:
      return action.payload.importing;
    default:
      return state;
  }
};

export const getIsImporting = state => state;